import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Payment } from '@kion/data-models';

@Component({
  selector: 'kion-payment-item',
  templateUrl: './payment-item.component.html',
  styleUrls: ['./payment-item.component.scss']
})
export class PaymentItemComponent {

  @Input() paymentMethod: Payment;
  @Input() hasIframe: boolean;
  @Input() selected: boolean;

  @Output('selected') paymentMethodSelectedEmitter: EventEmitter<Payment> = new EventEmitter<Payment>();

  paymentMethodSelected() {
    this.paymentMethodSelectedEmitter.emit(this.paymentMethod);
  }
}
